__webpack_require__.p = "/graph-widget/_next/";